module.exports = __webpack_public_path__ + "media/goforajourney/img/madrid-tour-99d315ca6ac77a9afe3165afd3ea441d.jpg";